module.exports = __webpack_public_path__ + "static/media/verticals2.bd2be35c.png";